<template>
  <v-container fluid>
    <v-row>
      <v-col xs="12" md="12" sm="12">
        <v-card>
          <v-card-title>Отчет по качеству операторов</v-card-title>
          <v-form ref="form">
            <!-- selectors -->
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="3" lg="3">
                  <date-time-picker v-model="date" :default="date"></date-time-picker>
                </v-col>
                 <v-col cols="12" sm="6" md="3" lg="3">
                  <group-selector noRules v-model="groups" @change:users="fillAgents" />
                 </v-col>
                 <v-col cols="12" sm="6" md="3" lg="3">
                  <user-selector v-model="agents" />
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" align="right">
                  <v-btn color="success" id="rep_btn" @click="loadReport" style="margin-top:13px;">Поиск</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mt-5">
      <v-data-table
          :headers="headers"
          :items="report"
          :items-per-page="report.length"
          :loading="loading"
          loading-text="Загрузка..."
          no-data-text="Ничего не найдено"
          hide-default-footer
      >
      <!-- header -->
        <template #[`header.dropped_calls_count`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-phone-remove</v-icon>
        </template>
        <template #[`header.hung_calls_count`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-sleep</v-icon>
        </template>
        <template #[`header.ignored_calls_count`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-phone-missed</v-icon>
        </template>
        <template #[`header.remarks_count`]="{ header }">
          <v-icon
            color="warning"
            :title="header.text"
          >mdi-account-alert</v-icon>
        </template>
        <template #[`header.gratitude_count`]="{ header }">
          <v-icon
            color="success"
            :title="header.text"
          >mdi-account-cash</v-icon>
        </template>
        <template #[`header.avg_kln`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-account-edit</v-icon>
        </template>
        <template #[`header.avg_duration_sec`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-clock</v-icon>
        </template>
        <template #[`header.long_hold_count`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-phone-paused</v-icon>
        </template>
        <template #[`header.agent_credibility`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-account-check</v-icon>
        </template>
        <template #[`header.sum_durations_min`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-phone-in-talk</v-icon>
        </template>
        <template #[`header.calls_count`]="{ header }">
          <v-icon
            :title="header.text"
          >mdi-phone-ring</v-icon>
        </template>

        <!--VIEW DIALOG-->
        <template #top>
          <dialog-view v-if="dialogView" v-model="dialogView" fullscreen title="Просмотр информации о проектах">
            <quality-info :sip="dialogViewSip" :period="dialogViewPeriod"></quality-info>
          </dialog-view>
          <!--END-->
        </template>

        <!-- items -->
        <template #[`item.user_name`]="{ item }">
          <span @click="viewItem(item)" class="regularLink">{{ item.user_name }}</span>
        </template>

      </v-data-table>
    </v-card>

  </v-container>
</template>

<script>
import moment from 'moment';
import {mapActions, mapGetters} from "vuex";
import UserSelector from '~/components/partials/selectors/UserSelector.vue';
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue';

export default {
  components: { UserSelector, GroupSelector },
  name: "OperatorsQuality",
  data() {
    return {
      date: {},
      agents: [],
      groups: [],
      headers: [
        {
          text: "Площадка",
          value: "location_name",
        },
        {
          text: "ФИО оператора",
          value: "user_name",
        },
        {
          text: "Колво сбросов, шт.",
          value: "dropped_calls_count",
        },
        {
          text: "Колво зависших каналов оператора, шт.",
          value: "hung_calls_count",
        },
        {
          text: "Колво игноров, шт.",
          value: "ignored_calls_count",
        },
        {
          text: "Кол-во офф. претензий, шт.",
          value: "remarks_count",
        },
        {
          text: "Колво благодарностей, шт.",
          value: "gratitude_count",
        },
        {
          text: "Средний КЛН, балл",
          value: "avg_kln",
        },
        {
          text: "Среднее время разговора, сек",
          value: "avg_duration_sec",
        },
        {
          text: "Колво длинных холдов, шт.",
          value: "long_hold_count",
        },
        {
          text: "Доступность оператора, %",
          value: "credibility",
        },
        // {
        //   text: "Колво проектов, шт.",
        //   value: "project_count",
        // },
        // {
        //   text: "Колво активных проектов, шт.",
        //   value: "active_project_count",
        // },
        {
          text: "Выговоренные минуты",
          value: "sum_duration_min",
        },
        {
          text: "Колво звонков обработанных операторов, шт",
          value: "calls_count",
        },
      ],
      dialogView: false,
      dialogViewSip: null,
      dialogViewPeriod: null,
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: "user/hasPermission",
      filteredAgents: "projects/filteredAgents",
      loading: "shared/getLoading",
      report: "operators/report",
    }),

    payload() {
      return {
        period: [
          moment(this.date.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.date.end).format('YYYY-MM-DD HH:mm:ss'),
        ],
        users: this.agents,
      }
    },
  },

  watch: {
    call(newVal) {
      if (newVal !== null) {
        this.dialogView = true;
      } else {
        this.dialogView = false;
      }
    },
  },

  methods: {
    ...mapActions({
      loadQualityOperatorsReport: "operators/loadQualityOperatorsReport",
      clearReport: "operators/clearReport",
      resetAllState: 'resetAllState',
    }),

    fillAgents(operators) {
      this.agents = operators;
    },

    viewItem(call) {
      this.dialogViewSip = call.sip;
      this.dialogViewPeriod = this.payload.period;
      this.dialogView = true;
    },

    async loadReport() {
      if (this.$refs.form.validate()) {
        await this.loadQualityOperatorsReport(this.payload);
      }
    },
  },

  async mounted() {
    this.clearReport();
  },

  beforeDestroy() {
    this.clearReport();
    this.resetAllState();
  },
}
</script>

<style scoped>
.regularLink {
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.3em;
}
.regularLink:hover {
  text-decoration: none;
  color: #030303ad;
}
</style>